import type { FaireProductEntity } from "../../entity_types/product";

export const p_5y8rzhha2h: FaireProductEntity = {
  token: "p_5y8rzhha2h",
  type: "product",
  name: "12552",
  brandToken: "b_7xmwfhpnh9",
  brandName: "AG Studio",
  imageUrl:
    "https://cdn.faire.com/fastly/14d8eea984feaeeee6add79ed5fd892c77adc32084d54d3223b3789b633599bf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/cfd5b2c7958b76bc1df93fae9840a3cd374743866b075cd9da145803a0c2ae97.jpeg",
    "https://cdn.faire.com/fastly/8ca040b15f0fbe38ba6907483ec1f75cca7790cd19c6518fffd3a6628206b166.jpeg",
  ],
  priceDollars: 9,
  description: "",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:56.516Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
